import { Routes } from '@angular/router';
import { ownerGuard } from '../../auth/guards/owner.guard';
import { TimesheetCalendarPageComponent } from './pages/timesheet-calendar-page/timesheet-calendar-page.component';
import { TimesheetPageComponent } from './pages/timesheet-page/timesheet-page.component';

export const timesheetRoutes: Routes = [
  {
    path: 'timesheet',
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/timesheet-page/timesheet-page.component').then(
            () => TimesheetPageComponent,
          ),
      },
      {
        path: 'calendar',
        loadComponent: () =>
          import('./pages/timesheet-calendar-page/timesheet-calendar-page.component').then(
            () => TimesheetCalendarPageComponent,
          ),
      },
      {
        path: 'owner',
        canActivate: [ownerGuard],
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./pages/timesheet-page/timesheet-page.component').then(
                () => TimesheetPageComponent,
              ),
          },
          {
            path: 'calendar',
            loadComponent: () =>
              import('./pages/timesheet-calendar-page/timesheet-calendar-page.component').then(
                () => TimesheetCalendarPageComponent,
              ),
          },
        ],
      },
      {
        path: 'bulk',
        canActivate: [ownerGuard],
        loadComponent: () =>
          import('./pages/timesheet-bulk-page/timesheet-bulk-page.component').then(
            (m) => m.TimesheetBulkPageComponent,
          ),
      },
    ],
  },
];
